import { platformNames } from '../constants/platform-names.contants';

export const getFullName = (platform, pharmacy) => {
	if (platform === platformNames.mkt) {
		return platformNames.mkt + ' ' + platformNames.tirxs;
	}
	return platformNames.ecc + ' ' + pharmacy.toUpperCase();
};
